import React from 'react';

const SkeletonLoaderTwo = () => {
  return (
    <div className="bg-[#0D0D0D] p-5 rounded-lg pt-20">
      <div className="flex flex-col gap-4">
        {[...Array(2)].map((_, index) => (
          <div
            key={index}
            className="h-[100px] bg-[rgba(45,45,45,0.5)] rounded-lg animate-wave"
          ></div>
        ))}
      </div>
      <style>{`
        @keyframes wave {
          0% {
            transform: scaleY(1);
          }
          50% {
            transform: scaleY(1.05);
          }
          100% {
            transform: scaleY(1);
          }
        }
        .animate-wave {
          animation: wave 1.5s infinite;
        }
      `}</style>
    </div>
  );
};

export default SkeletonLoaderTwo;